import {
  Component,
  OnInit,
} from '@angular/core';
import { ResetPasswordService } from 'src/app/core/services/resetPassword.service';
import { Subscription } from 'rxjs';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-generateToken',
  templateUrl: 'generateToken.component.html',
  styleUrls: ['./generateToken.component.css'],
})
export class GenerateTokenComponent implements OnInit {
  returnUrl: string;
  rememberMe = false;

  constructor(
    private resetPasswordService: ResetPasswordService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {
  }

  sub: Subscription;
  // error = {} as IError;
  isLoading = false;
  isStarting = false;

  ngOnInit(): void {
  }

  /**
   * is for attempting to generateToken with username and password.
   * @param e
   * @param generateTokenForm - is Angluar NgForm with email and password
   * @returns
   */
  attemptToGenerateToken(e: KeyboardEvent, generateTokenForm: NgForm) {
    if (e.repeat) {
      return;
    }

    if (generateTokenForm.invalid) {
      return;
    }

    // this.error.message = '';
    this.isLoading = true;

    const { userEmail } = generateTokenForm.value;

    this.resetPasswordService.generateToken(userEmail).subscribe((response) => {
      this.translate.get("generateToken.sent", { email: userEmail }).subscribe((text: string) => {
        this.toastr.info(text);
        this.isLoading = false;
      })
    }, (err) => {
      this.isLoading = false;
      switch (err.error.errorCode) {
        case 4040010: this.translate
          .get('generateToken.wrongMail')
          .subscribe((text: string) => {
            this.toastr.error(text);
          }); break;
        default: this.toastr.error(err.error.description); break;
      }
    });
  }

  ngOnDestroy() {
    // this.sub.unsubscribe();
  }
}

